import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import {initializeSentry} from './Monitoring/sentry';

const CHUNK_RELOAD_KEY = '__arcticwhale_chunk_reload__';

const isStaleChunkError = error => {
  const message = String(error?.message || error || '');
  const source = String(error?.filename || '');
  return (
    /chunk|loading javascript|dynamically imported module/i.test(message) ||
    /\.chunk\.js(?:\?|$)/i.test(source) ||
    /unexpected token ['"]?</i.test(message)
  );
};

const reloadAfterStaleChunk = error => {
  if (!isStaleChunkError(error)) return;

  try {
    const previousReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    if (previousReload && Date.now() - previousReload < 10000) {
      return;
    }
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch (_) {
    // Continue with the normal error screen if session storage is unavailable.
    return;
  }

  // Fetch a fresh HTML shell so it references the current chunk manifest.
  const url = new URL(window.location.href);
  url.searchParams.set('_build_reload', Date.now().toString());
  window.location.replace(url.toString());
};

window.addEventListener('error', event => reloadAfterStaleChunk(event.error || event));
window.addEventListener('unhandledrejection', event => reloadAfterStaleChunk(event.reason));

initializeSentry();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
